import React, { useState } from 'react';
import DocViewer from '../Template-Viewer/document-viewer';
import PagesPanel from '../pages-panel';
import { Send } from 'lucide-react';
export default function DcoDetailsViewer({ contract }) {
  const data = contract;

  console.log(
    '🚀 ~ file: template-viewer.js:13 ~ TemplateViewer ~ contract:',
    contract,
  );
  const [activePage, setActivePage] = useState('page-1');
  const handleFieldNavigation = (field) => {
    setActivePage(field.pageId);

    setTimeout(() => {
      const element = document.getElementById(field.id);

      if (element) {
        // Remove old active
        document
          .querySelectorAll('.placeholder-active')
          .forEach((el) => el.classList.remove('placeholder-active'));

        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });

        element.classList.add('placeholder-active');

        // Optional auto remove after delay
        setTimeout(() => {
          element.classList.remove('placeholder-active');
        }, 4000);
      }
    }, 300);
  };
  return (
    <div className="h-screen w-full flex overflow-hidden bg-slate-50 text-slate-800">
      {/* LEFT PAGE PANEL */}
      <aside
        className="
      w-64
      bg-white
      border-r border-slate-200
      overflow-y-auto
      hidden lg:block
      "
      >
        <PagesPanel
          pages={data?.pages}
          activePage={activePage}
          setActivePage={setActivePage}
          isEdit={false}
        />
      </aside>

      {/* CENTER DOCUMENT */}
      <main className="flex-1 flex flex-col min-w-0">
        {/* HEADER */}
        <header
          className="
h-16
bg-white
border-b
border-slate-200
px-6
flex
items-center
justify-between
"
        >
          <div>
            <h1 className="font-semibold text-lg">Contract Review</h1>

            <p className="text-xs text-slate-500">
              Assign placeholders before sending
            </p>
          </div>
        </header>

        {/* DOCUMENT */}
        <section
          className="
        flex-1
        overflow-auto
        bg-gradient-to-br
        from-slate-100
        to-indigo-50
        "
        >
          <DocViewer data={data} activePage={activePage} />
        </section>
      </main>
    </div>
  );
}
